import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const PromoBannerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  width: 100%;
  background-color: ${({ bgColor }) =>
    bgColor ? themeGet(`colors.${bgColor}`) : 'transparent'};
  height: calc(50% - 0.75rem);
  border-radius: 0.5rem;
  overflow: hidden;
`;

export const Content = styled.div`
  padding: 2rem;
  width: 100%;
  display: flex;
  align-items: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 2rem 1rem 2rem 2rem;
    width: 65%;
  }
`;

export const Heading = styled.h2`
  font-size: 1.5rem;
  line-height: 2.25rem;
  font-weight: ${themeGet('fontWeights.medium')};
  text-align: center;
  color: ${({ txtColor }) =>
    txtColor ? themeGet(`colors.white`) : themeGet(`colors.main-text`)};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2rem;
    text-align: left;
  }
`;

export const ImageWrapper = styled.div`
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    align-items: flex-end;
    width: 35%;
  }
`;
